module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', [_c('div', {
    staticClass: "row"
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    staticClass: "beepoint-svg text-center",
    on: {
      "click": _vm.onBeePoint
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/achieve/ic_beepoint.svg")
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "diamond-svg text-center",
    on: {
      "click": _vm.onDiamond
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/achieve/ic_diamond.svg")
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "honey-jars-svg text-center",
    on: {
      "click": _vm.onHoney
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/achieve/ic_honeyJars.svg")
    }
  })]), _vm._v(" "), (_vm.user.type_user === 1 || _vm.user.type_user === 3) ? _c('td', {
    staticClass: "rank-svg text-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/rank/Icon_level.svg")
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.user.type_user === 2) ? _c('td', {
    staticClass: "rating-svg text-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/achieve/ic_voteGV.svg")
    }
  })]) : _vm._e()]), _c('tr'), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "amount-title",
    on: {
      "click": _vm.onBeePoint
    }
  }, [_vm._v(_vm._s(_vm.numberWithCommas(_vm.beepoint)))]), _vm._v(" "), _c('td', {
    staticClass: "amount-title",
    on: {
      "click": _vm.onDiamond
    }
  }, [_vm._v(_vm._s(_vm.numberWithCommas(_vm.diamond)))]), _vm._v(" "), _c('td', {
    staticClass: "amount-title",
    on: {
      "click": _vm.onHoney
    }
  }, [_vm._v(_vm._s(_vm.numberWithCommas(_vm.honeyJars)))]), _vm._v(" "), (_vm.user.type_user === 1 || _vm.user.type_user === 3) ? _c('td', {
    staticClass: "amount-title"
  }, [_vm._v(_vm._s(_vm.user.rank.name))]) : _vm._e(), _vm._v(" "), (_vm.user.type_user === 2) ? _c('td', {
    staticClass: "amount-title"
  }, [_vm._v("4.5")]) : _vm._e()]), _c('tr'), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "text-center2"
  }, [_vm._v("điểm BeePoint")]), _vm._v(" "), _c('td', {
    staticClass: "text-center2"
  }, [_vm._v("điểm Diamond")]), _vm._v(" "), _c('td', {
    staticClass: "text-center2"
  }, [_vm._v("Hũ mật ong")]), _vm._v(" "), (_vm.user.type_user === 1 || _vm.user.type_user === 3) ? _c('td', {
    staticClass: "text-center2"
  }, [_vm._v("Hạng thành viên")]) : _vm._e(), _vm._v(" "), (_vm.user.type_user === 2) ? _c('td', {
    staticClass: "text-center2"
  }, [_vm._v("Đánh giá")]) : _vm._e()]), _c('tr')])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e085ea2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserProfile/Achieve.vue
// module id = 1523
// module chunks = 0